<template>
  <div>
    <textarea
      tag-name="textarea"
      :id="this.textarea_id"
      :name="name"
      :class="'textareaCkeditor ' + class_required"
    ></textarea>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ckeditorInstance: null,            
      textarea_id: null,
    };
  },
  props: {
    body: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    class_required: {
      type: String,
      required: false,
      default: "",
    },
    textarea_prop_id: {
      type: String,
      required: false,
      default: null,
    },
    enabled_paste_html: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  watch: {
    body() {
      this.setBody(this.body);
    },
  },
  methods: {
    setBody(body) {
      this.ckeditorInstance.value = body;
    },
    createSlugIdFromName(txt) {
      return txt
        .toLowerCase()
        .trim()
        .replace(/[^\w\s-]/g, "")
        .replace(/[\s_-]+/g, "-")
        .replace(/^-+|-+$/g, "");
    },
  },
  created() {
    //check textarea_id
    if (this.textarea_prop_id === null) {
      this.textarea_id = this.createSlugIdFromName(this.name);
    } else {
      this.textarea_id = this.textarea_prop_id;
    }
  },
  mounted() {

    this.ckeditorInstance = Jodit.make("#" + this.textarea_id, {
      "askBeforePasteHTML": this.enabled_paste_html,
      "askBeforePasteFromWord": this.enabled_paste_html,
      "defaultActionOnPaste": this.enabled_paste_html ? "insert_as_html" : "insert_only_text",
      events: {
        afterInit: function (editor) {
          let hrtButtonHidden = $("#" + editor.id)
            .parents("form")
            .find(".hrtButtonHidden");
          if (
            hrtButtonHidden != null &&
            hrtButtonHidden != undefined &&
            hrtButtonHidden.length > 0
          ) {
            editor.setDisabled(true);
          }
        },
        change: () => { this.$emit("update:description", { name: this.name, value: this.ckeditorInstance.value }) },
        blur: () => {
          saveAnswers(false)
        }
      },
      buttons: [
        "source",
        "|",
        "bold",
        "strikethrough",
        "underline",
        "italic",
        "|",
        "ul",
        "ol",
        "|",
        "outdent",
        "indent",
        "|",
        "font",
        "fontsize",
        "brush",
        "paragraph",
        "|",
        "image",
        "video",
        "table",
        "link",
        "|",
        "align",
        "undo",
        "redo",
        "|",
        "hr",
        "eraser",
        "copyformat",
        "|",
        "symbol",
        "fullsize",        
      ],
    });

    this.setBody(this.body);
  },
};
</script>